//
// Date & Time Picker
//
// ---------------------------------------------------------------------------

'use strict';

import 'eonasdan-bootstrap-datetimepicker';

const config = {
    target: '.js-date-time, .js-date'
};

export default class DateTimePicker {

    constructor() {
        let dateTimeFields = $(config.target);

        if(!dateTimeFields.length) {
            return;
        }

        this.initialisePickers(dateTimeFields);
    }

    /**
     * Set up all the date/time pickers on the page
     *
     * @param {jQuery} fieldContainers
     */
    initialisePickers(fieldContainers) {
        const dateTimePicker = this;

        fieldContainers.each(function() {
            let container = $(this);

            container.on(
                'dp.show',
                {
                    'container': container
                },
                dateTimePicker.highlightContainer
            );

            container.on(
                'dp.hide',
                {
                    'container': container
                },
                dateTimePicker.removeContainerHighlight
            );

            if (container.hasClass('js-date')) {
                container.datetimepicker({
                    allowInputToggle: true,
                    format: 'DD/MM/YYYY'
                });
            } else {
                container.datetimepicker({
                    allowInputToggle: true,
                    format: 'DD/MM/YYYY hh:mm A'
                });
            }
        });
    }

    /**
     * Adds focused class to the containing element when the datepicker is shown
     *
     * @param {Event} e jQuery enhanced event object
     */
    highlightContainer(e) {
        let container = e.data.container;

        container.addClass('is-focused');
    }

    /**
     * Removes focused class from the containing element when the datepicker is hidden
     *
     * @param {Event} e jQuery enhanced event object
     */
    removeContainerHighlight(e) {
        let container = e.data.container;

        container.removeClass('is-focused');
    }
}

$(window).load(function(){
    new DateTimePicker();
});



// WEBPACK FOOTER //
// ./src/js/components/date-time-picker.js